import { pipe } from 'ramda';
import { CategoryId } from 'api/timesheets/categories';
import { Deleting, Loaded } from 'core/state';
import { CategoriesStore, from, to } from './core';

export const deleting = (id: CategoryId) =>
  pipe(
    from,
    (store: CategoriesStore): CategoriesStore => {
      const { byId, ids, creating } = store;

      const { [id]: entry } = byId;
      const category = entry?.[1];

      if (category == null) {
        return store;
      }

      return {
        byId: { ...byId, [id]: Deleting(category) },
        ids,
        creating,
      };
    },
    to,
  );
export const deleted = (id: CategoryId) =>
  pipe(
    from,
    (store: CategoriesStore): CategoriesStore => {
      const { byId, ids, creating } = store;

      if (!(ids[1] ?? []).includes(id)) {
        return store;
      }

      const {
        [id]: [, category],
      } = byId;

      if (category == null) {
        return store;
      }

      return {
        byId: { ...byId, [id]: Loaded({ ...category, deleted: true }) },
        ids,
        creating,
      };
    },
    to,
  );

export const undeleted = (id: CategoryId) =>
  pipe(
    from,
    (store: CategoriesStore): CategoriesStore => {
      const { byId, ids, creating } = store;

      const { [id]: entry } = byId;
      const category = entry?.[1];

      if (category == null) {
        return store;
      }

      return {
        byId: { ...byId, [id]: Loaded(category) },
        ids,
        creating,
      };
    },
    to,
  );
